import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import Controllable from '../decorators/Controllable';
import SyntheticEvent from '../core/SyntheticEvent';
import UILink from '../link/UILink';
import UIControlledPopover from './UIControlledPopover';

class UIHelpLink extends Component {
  constructor(...args) {
    super(...args);

    this.handleLinkClick = evt => {
      const {
        disabled,
        onClick,
        onOpenChange,
        open
      } = this.props;
      if (disabled) return;
      if (onClick) onClick(evt);

      if (!evt.defaultPrevented && onOpenChange) {
        onOpenChange(SyntheticEvent(!open));
      }
    };
  }

  render() {
    const _this$props = this.props,
          {
      children,
      className,
      disabled,
      href,
      open
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "disabled", "href", "onClick", "open"]);

    return /*#__PURE__*/_jsx(UIControlledPopover, Object.assign({}, rest, {
      open: !disabled && open,
      use: "longform",
      children: /*#__PURE__*/_jsx(UILink, {
        className: className,
        href: href,
        onClick: this.handleLinkClick,
        disabled: disabled,
        children: children
      })
    }));
  }

}

UIHelpLink.propTypes = {
  // @ts-expect-error Suppress runtime prop type warning
  children: UILink.propTypes.children,
  // @ts-expect-error Suppress runtime prop type warning
  content: UIControlledPopover.propTypes.content,
  disabled: PropTypes.bool,
  // @ts-expect-error Suppress runtime prop type warning
  href: UILink.propTypes.href,
  // @ts-expect-error Suppress runtime prop type warning
  onOpenChange: UIControlledPopover.propTypes.onOpenChange,
  // @ts-expect-error Suppress runtime prop type warning
  open: UIControlledPopover.propTypes.open,
  // @ts-expect-error Suppress runtime prop type warning
  placement: UIControlledPopover.propTypes.placement,
  // @ts-expect-error Suppress runtime prop type warning
  showCloseButton: UIControlledPopover.propTypes.showCloseButton
};
UIHelpLink.defaultProps = {
  disabled: false,
  open: false,
  placement: 'top',
  showCloseButton: false
};
UIHelpLink.displayName = 'UIHelpLink';
export default Controllable(UIHelpLink, ['open']);